<template>
    <div class="job-detail" v-if="jobDetail">
        <div class="job-overview">
            <span class="job-status">招聘中</span>

            <div class="job-info flex-center">
                <div class="info-name ellipsis-single">{{ jobDetail.position_info.name }}</div>
                <div class="info-salary">{{ jobDetail.position_info.salary }}</div>
            </div>

            <div class="job-tags flex-center">
                <div class="info-address other-info">
                    <i class="el-icon-location"></i>
                    <span>{{ jobDetail.position_info.city }}</span>
                </div>

                <div class="info-experience other-info">
                    <i class="el-icon-s-cooperation"></i>
                    <span>{{ jobDetail.position_info.experience_type }} </span>
                </div>

                <div class="info-degree other-info">
                    <i class="el-icon-s-management"></i>
                    <span>{{ jobDetail.position_info.degree }}</span>
                </div>
            </div>

            <el-button type="primary" :disabled="jobDetail.apply_status === 1" @click="handleApply">
                {{ jobDetail.apply_status === 0 ? "立即投递" : "已投递" }}
            </el-button>
        </div>

        <div class="detail-box">
            <div class="detail-item desc">
                <span class="detail-item_title">职位描述</span>

                <div class="detail-item_tags">
                    <i class="tag" v-for="(tag, index) in jobDetail.position_info.position_keywords" :key="index">
                        {{ tag }}
                    </i>
                </div>

                <div class="detail-item_desc">
                    <div
                        class="desc-item"
                        v-for="(item, index) in jobDetail.position_info.position_introduction?.split('\n') || []"
                        :key="index"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>

            <div class="white-box">
                <div class="detail-item desc">
                    <span class="detail-item_title">公司介绍</span>

                    <div class="detail-item_desc">
                        <div class="desc-item" v-for="(item, index) in jobDetail.company_info.intro?.split('\n') || []" :key="index">
                            {{ item }}
                        </div>
                    </div>
                </div>

                <div class="detail-item business">
                    <span class="detail-item_title">工商信息</span>

                    <div class="detail-item_business">
                        <div class="grid-info">
                            <div class="info-item">
                                <div class="info-item_label">公司名称</div>
                                <div class="info-item_data">{{ jobDetail.company_info.name || "-" }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-item_label">法定代表人</div>
                                <div class="info-item_data">{{ "-" }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-item_label">成立日期</div>
                                <div class="info-item_data">{{ jobDetail.company_info.registration_date || "-" }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-item_label">企业类型</div>
                                <div class="info-item_data">{{ jobDetail.company_info.company_type || "-" }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-item_label">经营状态</div>
                                <div class="info-item_data">{{ jobDetail.company_info.business_status || "-" }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-item_label">注册资金</div>
                                <div class="info-item_data">{{ jobDetail.company_info.registered_capital || "-" }}万</div>
                            </div>
                        </div>

                        <div class="more flex-center">
                            <div class="more-btn flex-center">
                                <span>查看更多</span>
                                <i class="iconfont">&#xe771;</i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail-item address">
                    <span class="detail-item_title">工作地址</span>

                    <div class="detail-item_address">
                        <div class="address-text">
                            <i class="el-icon-location"></i>
                            <span>{{ work_address }}</span>
                        </div>

                        <div class="address-map" @click="mapVisible = true">
                            <MapBox :location="jobDetail.position_info.address.location"></MapBox>

                            <div class="view-more flex-center">
                                <img src="@/assets/map-icon.png" alt="" />
                                <span>点击查看地图</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <MapOverview v-model="mapVisible" :location="jobDetail.position_info.address.location"></MapOverview>
    </div>
</template>

<script>
import MapBox from "@/components/recruitmentCenter/job/MapBox.vue";
import MapOverview from "@/components/recruitmentCenter/job/MapOverview.vue";

export default {
    data() {
        return {
            jobDetail: undefined,
            mapVisible: false,
        };
    },

    created() {
        if (this.$route.query.id) this.getJobDetail();
    },

    components: {
        MapBox,
        MapOverview,
    },

    computed: {
        work_address() {
            const { province, city, district, address } = this.jobDetail.position_info.address;

            return `${province}${city}${district}${address}`;
        },
    },

    methods: {
        getJobDetail() {
            this.$httpStudent.axiosGetBy(this.$api.jobPositionDetail, { id: this.$route.query.id }, (res) => {
                if (res.code === 200) {
                    this.jobDetail = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 投递简历
        handleApply() {
            if (!this.jobDetail) return;

            this.$httpStudent.axiosPost(this.$api.jobApplyPosition, { position_id: this.jobDetail.position_info.id }, (res) => {
                if (res.code === 200) {
                    this.getJobDetail(false);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.job-detail {
    padding-top: 225px;

    * {
        box-sizing: border-box;
    }

    .el-button {
        --primary-color: #685ef5;
        --disabled-primary-color: rgba(104, 94, 245, 0.5);
        border-radius: 8px;

        &.el-button--primary {
            background-color: var(--primary-color);
            border-color: var(--primary-color);

            &.is-disabled {
                background-color: var(--disabled-primary-color);
                border-color: transparent;
            }
        }

        &.border-primary {
            border-color: var(--primary-color);
            color: var(--primary-color);
        }
    }

    .job-overview {
        padding-block: 20px;
        height: 225px;
        background: #302e4b;
        position: fixed;
        top: 60px;
        right: 0;
        left: 221px;
        padding-inline: 257px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .job-status {
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
        }

        .job-info {
            justify-content: flex-start;
            gap: 20px;

            .info-name {
                font-weight: bold;
                font-size: 28px;
                color: #ffffff;
            }

            .info-salary {
                font-weight: bold;
                font-size: 30px;
                color: #f26d4a;
                flex-shrink: 0;
            }
        }

        .job-tags {
            justify-content: flex-start;
            gap: 20px;

            .other-info {
                display: flex;
                align-content: center;

                i {
                    font-size: 16px;
                    line-height: 20px;
                    color: #ffffff;
                }

                span {
                    line-height: 20px;
                    color: #ffffff;
                }
            }
        }

        .el-button {
            width: 104px;
        }
    }

    .detail-box {
        padding-inline: 240px;

        .white-box {
            margin-top: 20px;
            background-color: #ffffff;
            border-radius: 12px;
        }

        .detail-item {
            background: #ffffff;
            border-radius: 12px;
            padding: 20px 30px;

            & + .detail-item {
                padding-top: 0;
            }

            &_title {
                font-weight: bold;
                font-size: 18px;
                color: #222222;
                display: inline-block;
                margin-bottom: 12px;
            }
        }

        .detail-item.desc {
            .detail-item_desc {
                font-weight: 400;
                font-size: 14px;
                color: #222222;
                line-height: 24px;
            }
        }

        .detail-item.business {
            .detail-item_business {
                background: #f8f8f9;
                border-radius: 12px;
                padding: 20px 20px 16px;

                .grid-info {
                    margin-bottom: 20px;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    row-gap: 20px;

                    .info-item {
                        min-width: 0;

                        &_label {
                            font-weight: 500;
                            font-size: 14px;
                            color: #99999a;
                            margin-bottom: 11px;
                        }

                        &_data {
                            font-weight: 500;
                            font-size: 14px;
                            color: #414a61;
                        }
                    }
                }

                .more {
                    .more-btn {
                        font-weight: 500;
                        font-size: 14px;
                        color: #00a6a8;
                        gap: 3px;
                        cursor: pointer;

                        .iconfont {
                            font-size: 12px;
                        }
                    }
                }
            }
        }

        .detail-item.address {
            .address-text {
                display: flex;
                align-content: center;

                i {
                    font-size: 16px;
                    line-height: 20px;
                    color: #d6d6d6;
                }

                span {
                    line-height: 20px;
                    color: #222223;
                }
            }

            .address-map {
                margin-top: 8px;
                height: 150px;
                border-radius: 8px;
                overflow: hidden;
                position: relative;

                .view-more {
                    position: absolute;
                    right: 12px;
                    bottom: 12px;
                    background-color: #ffffff;
                    border-radius: 8px;
                    gap: 4px;
                    padding: 4px 12px;
                    cursor: pointer;

                    img {
                        width: 24px;
                        height: 24px;
                        object-fit: cover;
                    }

                    span {
                        font-size: 12px;
                    }

                    &:hover {
                        span {
                            color: #685ef5;
                        }
                    }
                }
            }
        }
    }
}
</style>
